export const isRoleBorrowerAgent = (roles?: string[]) => (roles && roles?.indexOf('BORROWER_AGENT') >= 0);

export const isRoleOpsAgent = (roles?: string[]) => (roles && roles?.indexOf('CREDIT_OPS') >= 0);

export const isRoleFinanceAgent = (roles?: string[]) => (roles && roles?.indexOf('FINANCE_ADMIN') >= 0);

export const isRoleAdmin = (roles?: string[]) => (roles && roles?.indexOf('ADMIN') >= 0);
